// extracted by mini-css-extract-plugin
export default {"WaysToSave":"oKinwtiw","WaysToSaveText":"muTwEbww","WaysToSaveBox":"XcL_fsin","WaysToSaveBoxContainer":"h53sqcuA","WaysToSaveBoxIcon":"pyAgVYnr","WaysToSaveBoxNumber":"shvMj7jz"};